import { IReviewUser } from '../../interfaces/reviews';
import type { GlobalState } from '../index';
import { IUser } from '../reducers/user';

export const getUser = (state: GlobalState): IUser | null => (state.user.loggedIn ? state.user.account : null);
export const getUserInfo = (state: GlobalState): IReviewUser | null => state.user.info;
export const getIsUserLogged = (state: GlobalState): boolean => state.user.loggedIn;
export const getFingerprint = (state: GlobalState) => state.user.fp;
